import {FormSection} from '@/components/commons/form-section/FormSection'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {PlannedAccessesAbsenceFields} from '@/features/planned-accesses/components/accesses-form/planned-accesses-absence-fields/PlannedAccessesAbsenceFields'
import {PlannedAccessesElaborationsCard} from '@/features/planned-accesses/components/planned-accesses-elaborations-card/PlannedAccessesElaborationsCard'
import {PlannedAccessesTotalAbsencesCard} from '@/features/planned-accesses/components/planned-accesses-total-absences-card/PlannedAccessesTotalAbsencesCard'
import {PlannedAccessesFieldsSchema} from '@/features/planned-accesses/formSchemas'
import {usePlannedAccessesFormCounts} from '@/features/planned-accesses/hooks/usePlannedAccessesFormCounts'
import {useTranslation} from '@/translations/i18n'
import {useFormContext, useWatch} from 'react-hook-form'

export const PlannedAccessesFormAbsenceSection = () => {
    const {t} = useTranslation()
    const {control} = useFormContext<PlannedAccessesFieldsSchema>()

    // Extract form values using useWatch
    const projectId = useWatch({control, name: 'projectId'})
    const absenceAccesses = useWatch({control, name: 'absenceAccesses'}) || []
    const inPersonAccesses = useWatch({control, name: 'inPersonAccesses'}) || []
    const singleAccesses = useWatch({control, name: 'singleAccesses'}) || []

    const {
        project,
        isProjectLoading,
        totalProcessingAccesses,
        totalAbsencesAccessesCount,
        totalReportingAccessCount,
        unaccountedTotal,
        totalInPresenceAccessCount
    } = usePlannedAccessesFormCounts({
        projectId,
        absenceAccesses,
        inPersonAccesses,
        singleAccesses
    })

    return (
        <FormSection title={t('projects:access_in_absence')} hasBottomDivider fullWidth>
            <Flexbox direction="column" gap={6}>
                <PlannedAccessesTotalAbsencesCard
                    isLoading={isProjectLoading}
                    assistiveRegime={project?.assistiveRegime ?? null}
                    serviceType={project?.patient.serviceType ?? null}
                    totalInPresenceAccessesCount={totalInPresenceAccessCount}
                    totalAbsencesAccessesCount={totalAbsencesAccessesCount}
                />
                <PlannedAccessesElaborationsCard
                    totalProcessingAccesses={totalProcessingAccesses}
                    totalReportingAccessCount={totalReportingAccessCount}
                    unaccountedTotal={unaccountedTotal}
                />
                <PlannedAccessesAbsenceFields project={project} />
            </Flexbox>
        </FormSection>
    )
}
